var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthgenomBrokenHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52.0003,
    r: 52,
    fill: "#FFBD05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7797 66.4022L47.0764 65.0443L51.3528 50.321L43.8408 51.797L50.863 40.3411C47.9965 34.6639 42.0633 30.8271 35.2817 31.0063C25.9077 31.256 18.5174 39.056 18.7658 48.4205C18.9138 54.005 21.784 58.8431 26.0214 61.8228L25.9747 61.8527L52.1678 81.0003L52.1709 80.9987L51.7797 66.4022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1991 49.7682C87.8091 40.4209 80.7187 32.3419 71.3707 31.7323C64.4692 31.2818 58.2726 35.0341 55.251 40.7807L53.3901 47.6482L59.5469 48.5619L53.7699 62.5131L57.2831 64.0042L52.8604 80.833L79.4777 62.9126L79.431 62.8795C83.7845 60.0666 86.8351 55.3428 87.1986 49.7678L87.1991 49.7682Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthgenomBrokenHeart);
export default __webpack_public_path__ + "static/media/healthgenom_broken_heart.f7d06c22.svg";
export { ForwardRef as ReactComponent };